import { render, staticRenderFns } from "./pageIntro2nlp.vue?vue&type=template&id=108a224a&scoped=true&"
import script from "./pageIntro2nlp.vue?vue&type=script&lang=js&"
export * from "./pageIntro2nlp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a224a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
